import { useEffect } from 'react';
import { Message } from '@meitu/saas-ui';
import { getFramework, useIdentity } from '@/framework';
import { useLocaleStore } from '@/i18n';
import { EliminatePenController } from '../controller';

// ATTENTION: 当前只有主图支持在舞台上直接使用消除笔，这里就仅针对该场景进行处理
export const useEliminateInit = () => {
    const { $t } = useLocaleStore();

    const identity = useIdentity();
    const framework = getFramework(identity);
    const originIndex = framework.stage.getActiveOriginIndex();
    const controller = framework.getInstance(EliminatePenController);

    // 控制隐藏、显示素材层
    useEffect(() => {
        // 禁用图层选中事件，取消激活图层
        framework.operate.disablePick();
        framework.operate.disableActive();

        const scope = controller.getScope();

        setTimeout(() => {
            framework.operate.delActiveLayer();

            // 非画布消除模式下，不隐藏素材层和展示提示
            if (scope !== 'canvas') {
                const layers = framework.getLayers(originIndex);

                framework.stage.hideMaterial();

                // HACK: 当前的定义是只有主图和背景图层不属于素材层，同时一定会存在，这里先临时处理
                const hasMaterialLayer = layers.length > 2;

                if (hasMaterialLayer) {
                    Message.info($t((v) => v.mainLayer.operate.messageInfo));
                }
            }
        }, 0);

        return () => {
            if (scope !== 'canvas') {
                framework.stage.showMaterial();
            }
            // 恢复图层选中事件
            framework.operate.enablePick();
            framework.operate.enableActive();
        };
    }, []);
};
